import React, { useRef, useState, useEffect } from "react";
import CyberBay from "../../../assets/img/CyberBayFinalBlueLogo.png";
import Tevel from "../../../assets/img/TevelCyberFinalBlueLogo.png";
import { Link } from "react-router-dom";

// Headings and Sections, in exact order
const sidebarItems = [
  "Privacy Policy",
  "Collecting and Using Your Personal Data",
  "Tracking Technologies and Cookies",
  "Use of Your Personal Data",
  "Retention of Your Personal Data",
  "Other legal requirements",
];

const sections = [
  {
    id: "privacy-policy",
    title: "Privacy Policy",
    content: (
      <>
        <p>
          Last updated: June 27, 2025
          <br />
          <br />
          This Privacy Policy describes Our policies and procedures on the
          collection, use and disclosure of Your information when You use the
          Service and tells You about Your privacy rights and how the law
          protects You. <br />
          <br /> We use Your Personal data to provide and improve the Service.
          By using the Service, You agree to the collection and use of
          information in accordance with this Privacy Policy.
        </p>
        <h4 style={{ marginTop: 20 }}>Interpretation and Definitions</h4>
        <p>
          <b>Interpretation</b>
          <br />
          The words of which the initial letter is capitalized have meanings
          defined under the following conditions. The following definitions
          shall have the same meaning regardless of whether they appear in
          singular or in plural.
          <br />
          <br />
          <b>Definitions</b>
          <br />
          <ul style={{ marginTop: 10 }}>
            <li>
              <b>Account</b> means a unique account created for You to access
              our Service or parts of our Service.
            </li>
            <li>
              <b>Affiliate</b> means an entity that controls, is controlled by
              or is under common control with a party, where "control" means
              ownership of 50% or more of the shares, equity interest or other
              securities entitled to vote for election of directors or other
              managing authority.
            </li>
            <li>
              <b>Application</b> refers to Cyberbay, the software program
              provided by the Company.
            </li>
            <li>
              <b>Company</b> (referred to as either "the Company", "We", "Us" or
              "Our" in this Agreement) refers to Tevel Cyber Corps Private Limited, GRR Business Centre, New No. 36, Old No. 21, 3rd Floor, Vaidyaraman Street, T Nagar, Chennai, Tamil Nadu, India, 600017.
            </li>
            <li>
              <b>Cookies</b> are small files that are placed on Your computer,
              mobile device or any other device by a website, containing the
              details of Your browsing history on that website among its many
              uses.
            </li>
            <li>
              <b>Country</b> refers to: India.
            </li>
            <li>
              <b>Device</b> means any device that can access the Service such as
              a computer, a cellphone or a digital tablet.
            </li>
            <li>
              <b>Personal Data</b> is any information that relates to an
              identified or identifiable individual.
            </li>
            <li>
              <b>Service</b> refers to the Application or the Website or both.
            </li>
            <li>
              <b>Service Provider</b> means any natural or legal person who
              processes the data on behalf of the Company. It refers to
              third-party companies or individuals employed by the Company to
              facilitate the Service, to provide the Service on behalf of the
              Company, to perform services related to the Service or to assist
              the Company in analyzing how the Service is used.
            </li>
            <li>
              <b>Usage Data</b> refers to data collected automatically, either
              generated by the use of the Service or from the Service
              infrastructure itself (for example, the duration of a page visit).
            </li>
            <li>
              <b>Website</b> refers to Cyberbay, accessible from{" "}
              <a
                className="link"
                href="https://thecyberbay.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://thecyberbay.com
              </a>
            </li>
            <li>
              <b>You</b> means the individual accessing or using the Service, or
              the company, or other legal entity on behalf of which such
              individual is accessing or using the Service, as applicable.<br/><br/>
            </li>
          </ul>
        </p>
      </>
    ),
  },
  {
    id: "data-collection",
    title: "Collecting and Using Your Personal Data",
    content: (
      <>
        <p>
          <b>Types of Data Collected</b>
          <br />
        </p>
        <p>
          <b>Personal Data </b>
          <p>
            While using Our Service, We may ask You to provide Us with certain
            personally identifiable information that can be used to contact or
            identify You. Personally identifiable information may include, but
            is not limited to:
          </p>
          <ul style={{ marginTop: 10 }}>
            <li>First name and last name</li>
            <li>Email address</li>
            <li>Mobile Number</li>
            <li>Address, State, Province, ZIP/Postal code, City</li>
            <li>Usage Data</li>
          </ul>
        </p>
        <p>
          <b>Usage Data</b>
          <br />
          Usage Data is collected automatically when using the Service.
          <br />
          <br />
          Usage Data may include information such as Your Device's Internet
          Protocol address (e.g. IP address), browser type, browser version, the
          pages of our Service that You visit, the time and date of Your visit,
          the time spent on those pages, unique device identifiers and other
          diagnostic data.
          <br />
          <br />
          When You access the Service by or through a mobile device, We may
          collect certain information automatically, including, but not limited
          to, the type of mobile device You use, Your mobile device unique ID,
          the IP address of Your mobile device, Your mobile operating system,
          the type of mobile Internet browser You use, unique device identifiers
          and other diagnostic data.
          <br />
          <br />
          We may also collect information that Your browser sends whenever You
          visit our Service or when You access the Service by or through a
          mobile device.
          <br />
          You can enable or disable access to this information at any time,
          through Your Device settings.<br/><br/>
        </p>
      </>
    ),
  },
  {
    id: "cookies",
    title: "Tracking Technologies and Cookies",
    content: (
      <>
        <p>
          We use Cookies and similar tracking technologies to track the activity
          on Our Service and store certain information. Tracking technologies
          used are beacons, tags, and scripts to collect and track information
          and to improve and analyse Our Service. The technologies We use may
          include:
        </p>
        <ul style={{ marginTop: 10 }}>
          <li>
            <b>Cookies or Browser Cookies</b>. A cookie is a small file placed
            on Your Device. You can instruct Your browser to refuse all Cookies
            or to indicate when a Cookie is being sent. However, if You do not
            accept Cookies, You may not be able to use some parts of our
            Service. Unless you have adjusted Your browser setting so that it
            will refuse Cookies, our Service may use Cookies.
          </li>
          <li>
            <b>Web Beacons</b>. Certain sections of our Service and our emails
            may contain small electronic files known as web beacons (also
            referred to as clear gifs, pixel tags, and single-pixel gifs) that
            permit the Company, for example, to count users who have visited
            those pages or opened an email and for other related website
            statistics (for example, recording the popularity of a certain
            section and verifying system and server integrity).
            <br />
            Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies
            remain on Your personal computer or mobile device when You go
            offline, while Session Cookies are deleted as soon as You close Your
            web browser.
            <br />
            We use both Session and Persistent Cookies for the purposes set out
            below:
          </li>
          <li>
            <b>Necessary / Essential Cookies</b>.
            <br />
            <b>Type</b>: Persistent Cookies
            <br /> <b>Administered by</b>: Us
            <br /> <b>Purpose</b>: These Cookies allow us to remember choices
            You make when You use the Website, such as remembering your login
            details or language preference. The purpose of these Cookies is to
            provide You with a more personal experience and to avoid You having
            to re-enter your preferences every time You use the Website.
            <br />
            <br />
            For more information about the cookies we use and your choices
            regarding cookies, please visit our Cookies Policy or the Cookies
            section of our Privacy Policy.<br/><br/>
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "use-personal-data",
    title: "Use of Your Personal Data",
    content: (
      <>
        <p>The Company may use Personal Data for the following purposes:</p>
        <ul style={{ marginTop: 10 }}>
          <li>
            <b>To provide and maintain our Service</b>, including to monitor the
            usage of our Service.
          </li>
          <li>
            <b>To Manage Your Account</b>: To manage Your registration as a user
            of the Service. The Personal Data You provide can give You access to
            different functionalities of the Service that are available to You
            as a registered user.
          </li>
          <li>
            <b>For the performance of a contract</b>: The development,
            compliance and undertaking of the purchase contract for the
            products, items or services You have purchased or of any other
            contract with Us through the Service.
          </li>
          <li>
            <b>To contact You</b>: To contact You by email, telephone calls,
            SMS, or other equivalent forms of electronic communication, such as
            a mobile application's push notifications regarding updates or
            informative communications related to the functionalities, products
            or contracted services, including the security updates, when
            necessary or reasonable for their implementation.
          </li>
          <li>
            <b>To provide You</b> with news, special offers and general
            information about other goods, services and events which we offer
            that are similar to those that you have already purchased or
            enquired about unless You have opted not to receive such
            information.
          </li>
          <li>
            <b>To manage Your requests</b>: To attend and manage Your requests
            to Us.
          </li>
          <li>
            <b>For business transfers</b>: We may use Your information to
            evaluate or conduct a merger, divestiture, restructuring,
            reorganization, dissolution, or other sale or transfer of some or
            all of Our assets, whether as a going concern or as part of
            bankruptcy, liquidation, or similar proceeding, in which Personal
            Data held by Us about our Service users is among the assets
            transferred.
          </li>
          <li>
            <b>For other purposes</b>: We may use Your information for other
            purposes, such as data analysis, identifying usage trends,
            determining the effectiveness of our promotional campaigns and to
            evaluate and improve our Service, products, services, marketing and
            your experience.
          </li>
        </ul>
        <p>
          We may share Your personal information in the following situations:{" "}
        </p>
        <ul style={{ marginTop: 10 }}>
          <li>
            <b>With Service Providers</b>: We may share Your personal
            information with Service Providers to monitor and analyze the use of
            our Service, to contact You.
          </li>
          <li>
            <b>For business transfers</b>: We may share or transfer Your
            personal information in connection with, or during negotiations of,
            any merger, sale of Company assets, financing, or acquisition of all
            or a portion of Our business to another company
          </li>
          <li>
            <b>With Affiliates</b>: We may share Your information with Our
            affiliates, in which case we will require those affiliates to honor
            this Privacy Policy. Affiliates include Our parent company and any
            other subsidiaries, joint venture partners or other companies that
            We control or that are under common control with Us.
          </li>
          <li>
            <b>With business partners</b>: We may share Your information with
            Our business partners to offer You certain products, services or
            promotions.
          </li>
          <li>
            <b>With other users</b>: When You share personal information or
            otherwise interact in the public areas with other users, such
            information may be viewed by all users and may be publicly
            distributed outside.
          </li>
          <li>
            <b>With Your consent</b>: We may disclose Your personal information
            for any other purpose with Your consent.<br/><br/>
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "retention",
    title: "Retention of Your Personal Data",
    content: (
      <>

        <p>
          The Company will retain Your Personal Data only for as long as is
          necessary for the purposes set out in this Privacy Policy. We will
          retain and use Your Personal Data to the extent necessary to comply
          with our legal obligations (for example, if we are required to retain
          your data to comply with applicable laws), resolve disputes, and
          enforce our legal agreements and policies. <br />
          <br />
          The Company will also retain Usage Data for internal analysis
          purposes. Usage Data is generally retained for a shorter period of
          time, except when this data is used to strengthen the security or to
          improve the functionality of Our Service, or We are legally obligated
          to retain this data for longer time periods. <br />
          <br />
        </p>
        <h4>Transfer of Your Personal Data</h4>
        <p>
          Your information, including Personal Data, is processed at the
          Company's operating offices and in any other places where the parties
          involved in the processing are located. It means that this information
          may be transferred to — and maintained on — computers located outside
          of Your state, province, country or other governmental jurisdiction
          where the data protection laws may differ than those from Your
          jurisdiction.
          <br />
          <br />
          Your consent to this Privacy Policy followed by Your submission of
          such information represents Your agreement to that transfer. <br />
          The Company will take all steps reasonably necessary to ensure that
          Your data is treated securely and in accordance with this Privacy
          Policy and no transfer of Your Personal Data will take place to an
          organization or a country unless there are adequate controls in place
          including the security of Your data and other personal information.{" "}
          <br />
          <br />
        </p>
        <h4>Delete Your Personal Data </h4>
        <p>
          You have the right to delete or request that We assist in deleting the
          Personal Data that We have collected about You. <br />
          Our Service may give You the ability to delete certain information
          about You from within the Service. <br />
          You may update, amend, or delete Your information at any time by
          signing in to Your Account, if you have one, and visiting the account
          settings section that allows you to manage Your personal information.
          You may also contact Us to request access to, correct, or delete any
          personal information that You have provided to Us. <br />
          <br />
          Please note, however, that We may need to retain certain information
          when we have a legal obligation or lawful basis to do so. <br />
          <br />
        </p>
        <h4>Disclosure of Your Personal Data </h4>
        <b>Business Transactions </b>
        <br />
        <p>
          If the Company is involved in a merger, acquisition or asset sale,
          Your Personal Data may be transferred. We will provide notice before
          Your Personal Data is transferred and becomes subject to a different
          Privacy Policy. <br />
        </p>
        <b>Law enforcement</b>
        <br />
        <p>
          Under certain circumstances, the Company may be required to disclose
          Your Personal Data if required to do so by law or in response to valid
          requests by public authorities (e.g. a court or a government agency).{" "}
          <br />
          <br />
        </p>
      </>
    ),
  },
  {
    id: "legal",
    title: "Other legal requirements",
    content: (
      <>

        <p>
          The Company may disclose Your Personal Data in the good faith belief
          that such action is necessary to:{" "}
        </p>
        <div>
          <ul style={{ marginTop: 10 }}>
            <li>Comply with a legal obligation</li>
            <li>Protect and defend the rights or property of the Company</li>
            <li>
              Prevent or investigate possible wrongdoing in connection with the
              Service
            </li>
            <li>
              Protect the personal safety of Users of the Service or the public
            </li>
            <li>Protect against legal liability</li>
          </ul>
          <b>Security of Your Personal Data </b>
          <br />
          <p>
            The security of Your Personal Data is important to Us, but remember
            that no method of transmission over the Internet, or method of
            electronic storage is 100% secure. While We strive to use
            commercially acceptable means to protect Your Personal Data, We
            cannot guarantee its absolute security.
          </p>
          <b>Children's Privacy </b>
          <br />
          <p>
            Our Service does not address anyone under the age of 13. We do not
            knowingly collect personally identifiable information from anyone
            under the age of 13. If You are a parent or guardian and You are
            aware that Your child has provided Us with Personal Data, please
            contact Us. If We become aware that We have collected Personal Data
            from anyone under the age of 13 without verification of parental
            consent, We take steps to remove that information from Our servers.
            <br />
            If We need to rely on consent as a legal basis for processing Your
            information and Your country requires consent from a parent, We may
            require Your parent's consent before We collect and use that
            information.
          </p>
          <b>Links to Other Websites </b>
          <br />
          <p>
            Our Service may contain links to other websites that are not
            operated by Us. If You click on a third party link, You will be
            directed to that third party's site. We strongly advise You to
            review the Privacy Policy of every site You visit. <br />
            We have no control over and assume no responsibility for the
            content, privacy policies or practices of any third party sites or
            services.
          </p>
          <b>Changes to this Privacy Policy </b>
          <br />
          <p>
            We may update Our Privacy Policy from time to time. We will notify
            You of any changes by posting the new Privacy Policy on this page.{" "}
            <br />
            We will let You know via email and/or a prominent notice on Our
            Service, prior to the change becoming effective and update the "Last
            updated" date at the top of this Privacy Policy.
            <br />
            You are advised to review this Privacy Policy periodically for any
            changes. Changes to this Privacy Policy are effective when they are
            posted on this page.
          </p>
          <b>Contact Us </b>
          <br />
          <p>
            If you have any questions about this Privacy Policy, You can contact
            us:
          </p>
          <ul style={{ marginTop: 10 }}>
            <li>
              By email: <a className="link ms-1" href="mailto:support@tevelcyber.com">support@tevelcyber.com</a>
            </li>
            <li>
              By visiting this page on our website: 
              <a
                className="link ms-1"
                href="https://thecyberbay.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://thecyberbay.com
              </a>
            </li>
          </ul>
        </div>
      </>
    ),
  },
];

const AnimatedTitle = ({ text }) => (
  <h2
    key={text}
    className="terms-title animate-letters mx-auto mt-3 mb-0"
  >
    <span className="animated-letter">{text}</span>
  </h2>
);

const TermsAndConditions = () => {
const [activeId, setActiveId] = useState(sections[0].id);
const isClickScrolling = useRef(false);
  const sectionRefs = useRef(
    sections.reduce((acc, section) => {
      acc[section.id] = React.createRef();
      return acc;
    }, {})
  );
  const scrollContainerRef = useRef(null);

  // Handle sidebar click to scroll to section
const handleSidebarClick = (i) => {
  const id = sections[i].id;

  isClickScrolling.current = true;
  setActiveId(id);

  const target = sectionRefs.current[id].current;

  if (target) {
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  setTimeout(() => {
    isClickScrolling.current = false;
  }, 600);
};

  useEffect(() => {
    const currentSectionRefs = sectionRefs.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
if (entry.isIntersecting && !isClickScrolling.current) {
  setActiveId(entry.target.id);
}
        });
      },
      {
        root: scrollContainerRef.current,
        threshold: 0.5,
      }
    );
    Object.values(currentSectionRefs).forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });
    return () => {
      Object.values(currentSectionRefs).forEach((ref) => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      });
    };
  }, []); 

  return (
    <div
      className="d-flex justify-content-center align-items-start main-terms-bg"
      style={{
        paddingTop: "20px",
        minHeight: "100vh",
      }}
    >
      <div style={{ width: "85vw" }}>
        {/* Top Logos and Title */}
        <div
          className="d-flex flex-column align-items-center mb-4 position-relative"
        >
          <div
            className="d-flex justify-content-between align-items-center w-100"
            style={{ position: "relative", minHeight: 60 }}
          >
            <Link to="/login">
              <img
                src={Tevel}
                alt="Left Logo"
                style={{ maxWidth: "180px", minHeight: "60px" }}
              />
            </Link>
            <Link to="/login">
              <img
                src={CyberBay}
                alt="Right Logo"
                style={{
                  maxWidth: "120px",
                  minHeight: "60px",
                  cursor: "pointer",
                }}
              />
            </Link>
          </div>
             <AnimatedTitle
  text={
    sections.find((section) => section.id === activeId)?.title || ""
  }
/>
        </div>

        {/* Main Content Row */}
        <div
          className="shadow d-flex flex-column flex-md-row"
          style={{
            gap: "20px",
          }}
        >
          {/* Sidebar */}
          <div
            className="bg-white shadow flex-shrink-0"
            style={{
              minWidth: "250px",
              maxWidth: "350px",
              paddingTop: "32px",
            }}
          >
            {sidebarItems.map((item, i) => (
              <button
                key={item}
                className={`terms-sidebar-button ${
                  activeId === sections[i].id ? "active" : ""
                }`}
                onClick={() => handleSidebarClick(i)}
                type="button"
              >
                {item}
              </button>
            ))}
          </div>

          {/* Main Content */}
          <div
            className="bg-white shadow flex-grow-1 d-flex flex-column"
            style={{ paddingTop: 10 }}
          >
            <div
              ref={scrollContainerRef}
              className="scroll-no-buttons terms-scroll px-3 px-md-5 py-4"
              style={{ overflowY: "auto", maxHeight: "80vh" }}
            >
              {sections.map((section) => (
                <div
                  key={section.id}
                  id={section.id}
                  ref={sectionRefs.current[section.id]}
                  className="terms-section-content"
                >
                  {section.content}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;